// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 1. Force the backdrop overlay to be full-screen, fixed, and semi-transparent */
.preferences-modal-wrapper .overlay,
div:has(> .preferences-modal) {
  top: 0 !important;
  left: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
  background-color: rgba(0, 0, 0, 0.5) !important; /* Semi-transparent dark overlay */
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  z-index: 1300 !important; /* Ensure it floats above Material UI elements */
}

/* 2. Style the center box container created by CenterModule */
.preferences-modal-wrapper .centered-module,
.preferences-modal {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.25);
  max-width: 650px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  box-sizing: border-box;
}

/* 3. Modal Content Styling */
.preferences-modal {
  padding: 28px;
  width: 100%;
  font-family: 'Open Sans', sans-serif;
  color: #1e293b;
  text-align: left;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-header h2 {
  font-size: 1.2rem;
  font-weight: 700;
  color: #0f4c81;
  margin: 0;
}

.close-btn {
  background: transparent;
  border: none;
  font-size: 1.5rem;
  color: #0f4c81;
  cursor: pointer;
  line-height: 1;
}

.divider {
  border: none;
  border-top: 1px solid #e2e8f0;
  margin: 16px 0;
}

.section {
  margin-bottom: 20px;
}

.section-title {
  font-size: 0.9rem;
  font-weight: 600;
  color: #0f4c81;
  margin-bottom: 12px;
}

.radio-group, .checkbox-group {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.radio-group.horizontal, .checkbox-group {
  flex-direction: row;
  gap: 32px;
}

.radio-label, .checkbox-label {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  font-size: 0.875rem;
  color: #334155;
  cursor: pointer;
}

.radio-label input[type="radio"],
.checkbox-label input[type="checkbox"] {
  margin-top: 2px;
  accent-color: #0066cc;
  width: 16px;
  height: 16px;
  cursor: pointer;
}

.modal-footer {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  margin-top: 16px;
}

.btn {
  flex: 1 1;
  padding: 12px 20px;
  border-radius: 6px;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
}

.btn-cancel {
  background-color: #ffffff;
  color: #0f4c81;
  border: 1.5px solid #0f4c81;
}

.btn-cancel:hover {
  background-color: #f8fafc;
}

.btn-confirm {
  background-color: #1d70b8;
  color: #ffffff;
  border: none;
}

.btn-confirm:hover {
  background-color: #155a96;
}

.btn-confirm:disabled {
  background-color: #cbd5e1;
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/components/SetPackingPreferencesModal/SetPackingPreferencesModal.css"],"names":[],"mappings":"AAAA,iFAAiF;AACjF;;EAEE,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;EACxB,+CAA+C,EAAE,kCAAkC;EACnF,wBAAwB;EACxB,kCAAkC;EAClC,8BAA8B;EAC9B,wBAAwB,EAAE,gDAAgD;AAC5E;;AAEA,8DAA8D;AAC9D;;EAEE,mBAAmB;EACnB,mBAAmB;EACnB,2CAA2C;EAC3C,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,WAAW;EACX,oCAAoC;EACpC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,eAAe;EACf,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB","sourcesContent":["/* 1. Force the backdrop overlay to be full-screen, fixed, and semi-transparent */\n.preferences-modal-wrapper .overlay,\ndiv:has(> .preferences-modal) {\n  top: 0 !important;\n  left: 0 !important;\n  width: 100vw !important;\n  height: 100vh !important;\n  background-color: rgba(0, 0, 0, 0.5) !important; /* Semi-transparent dark overlay */\n  display: flex !important;\n  justify-content: center !important;\n  align-items: center !important;\n  z-index: 1300 !important; /* Ensure it floats above Material UI elements */\n}\n\n/* 2. Style the center box container created by CenterModule */\n.preferences-modal-wrapper .centered-module,\n.preferences-modal {\n  background: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.25);\n  max-width: 650px;\n  width: 90%;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-sizing: border-box;\n}\n\n/* 3. Modal Content Styling */\n.preferences-modal {\n  padding: 28px;\n  width: 100%;\n  font-family: 'Open Sans', sans-serif;\n  color: #1e293b;\n  text-align: left;\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.modal-header h2 {\n  font-size: 1.2rem;\n  font-weight: 700;\n  color: #0f4c81;\n  margin: 0;\n}\n\n.close-btn {\n  background: transparent;\n  border: none;\n  font-size: 1.5rem;\n  color: #0f4c81;\n  cursor: pointer;\n  line-height: 1;\n}\n\n.divider {\n  border: none;\n  border-top: 1px solid #e2e8f0;\n  margin: 16px 0;\n}\n\n.section {\n  margin-bottom: 20px;\n}\n\n.section-title {\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: #0f4c81;\n  margin-bottom: 12px;\n}\n\n.radio-group, .checkbox-group {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.radio-group.horizontal, .checkbox-group {\n  flex-direction: row;\n  gap: 32px;\n}\n\n.radio-label, .checkbox-label {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  font-size: 0.875rem;\n  color: #334155;\n  cursor: pointer;\n}\n\n.radio-label input[type=\"radio\"],\n.checkbox-label input[type=\"checkbox\"] {\n  margin-top: 2px;\n  accent-color: #0066cc;\n  width: 16px;\n  height: 16px;\n  cursor: pointer;\n}\n\n.modal-footer {\n  display: flex;\n  justify-content: space-between;\n  gap: 16px;\n  margin-top: 16px;\n}\n\n.btn {\n  flex: 1;\n  padding: 12px 20px;\n  border-radius: 6px;\n  font-size: 0.95rem;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.btn-cancel {\n  background-color: #ffffff;\n  color: #0f4c81;\n  border: 1.5px solid #0f4c81;\n}\n\n.btn-cancel:hover {\n  background-color: #f8fafc;\n}\n\n.btn-confirm {\n  background-color: #1d70b8;\n  color: #ffffff;\n  border: none;\n}\n\n.btn-confirm:hover {\n  background-color: #155a96;\n}\n\n.btn-confirm:disabled {\n  background-color: #cbd5e1;\n  cursor: not-allowed;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
